import { useState, useEffect } from 'react';

const COUNTDOWN_LENGTH = 60; // 倒计时长度（秒）
// const COUNTDOWN_LENGTH = 10; // 倒计时长度（秒）

export default function useCountdown() {
  const [countdown, setCountdown] = useState(COUNTDOWN_LENGTH);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    if (isRunning && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prevCount) => prevCount - 1);
      }, 1000);

      // 清除定时器
      return () => clearInterval(timer);
    }
    resetCountdown();
  }, [isRunning, countdown]);

  const startCountdown = () => {
    setIsRunning(true);
  };

  const resetCountdown = () => {
    setCountdown(COUNTDOWN_LENGTH);
    setIsRunning(false);
  };

  return { countdown, isRunning, startCountdown, resetCountdown };
}
